import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

const LegalMentions: React.FC = () => {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
                    Mentions Légales
                </Typography>

                <Divider sx={{ mb: 3 }} />

                {/* Informations sur l'entreprise */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom color="primary">
                        1. Informations sur l'entreprise
                    </Typography>
                    <Typography variant="body1" paragraph>
                        <strong>Raison sociale :</strong> LAGUNE PLONGEE<br />
                        <strong>Forme juridique :</strong> SARL unipersonnelle<br />
                        <strong>Capital social :</strong> 2 000,00 €<br />
                        <strong>RCS :</strong> Perpignan B 518 987 383<br />
                        <strong>SIREN :</strong> 518 987 383<br />
                        <strong>SIRET :</strong> 518 987 383 00024<br />
                        <strong>N° TVA Intracommunautaire :</strong> FR29 518 987 383
                    </Typography>

                    <Typography variant="body1" paragraph>
                        <strong>Adresse du siège social :</strong><br />
                        Résidence le YACHTMAN<br />
                        Quai Arthur RIMBAUD<br />
                        66750 SAINT-CYPRIEN<br />
                        France
                    </Typography>

                    <Typography variant="body1" paragraph>
                        <strong>Gérant :</strong> M. Rodolphe ZOLIN<br />
                        <strong>Téléphone :</strong> 06 13 78 86 11<br />
                        <strong>Email :</strong> infolaguneplongee@gmail.com<br />
                        <strong>Site web :</strong> http://www.laguneplongee.com
                    </Typography>
                </Box>

                {/* Activité */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom color="primary">
                        2. Activité
                    </Typography>
                    <Typography variant="body1" paragraph>
                        <strong>Code APE :</strong> 8551Z - Enseignement de disciplines sportives et d'activités de loisirs<br />
                        <strong>Catégorie :</strong> Enseignement<br />
                        <strong>Effectif :</strong> 1 à 2 salariés<br />
                        <strong>Date d'immatriculation :</strong> 29 décembre 2009
                    </Typography>
                </Box>

                {/* Conditions générales de vente */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom color="primary">
                        3. Conditions Générales de Vente
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 0 - Validité de l'achat
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Tout achat sur le site sans sélection de produit (soit zéro euro, 0€) ne vaut pas pour achat ou réservation des prestations. Il faut sélectionner le ou les prestations et procéder au paiement en ligne par les différents moyens proposés.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 1 - Nombre de participants minimum
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Le nombre de participants minimum pour garantir le départ d'une formation est de 1 personne. Si ce nombre n'est pas atteint, nous vous proposerons de différer vos dates.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 2 - Conditions d'âge et sécurité
                    </Typography>
                    <Typography variant="body1" paragraph>
                        La plongée sous-marine est une activité accessible à partir de 5 ans. Il vous est demandé de respecter nos consignes de sécurité rappelant les risques inhérents à la pratique de l'activité plongée sous-marine, notamment ceux concernant l'équilibrage de vos oreilles et les principes de ventilation en plongée. Ces dernières seront expliquées lors du briefing effectué par les encadrants. Une autorisation parentale pour mineur est obligatoire.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 3 - Annulation pour cas de force majeure
                    </Typography>
                    <Typography variant="body1" paragraph>
                        En cas d'évènements exceptionnels, cas de force majeure, d'évènements imprévisibles où pour assurer la sécurité des participants, Lagune Plongée se réserve la possibilité d'annuler l'activité. Dans ce cas le client aura la possibilité d'effectuer la prestation à une autre date de son choix. Il ne sera pas procédé au remboursement de la prestation.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 4 - Modalités de paiement
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Les prestations sont réglées en totalité avant le démarrage de l'activité par système de paiement sécurisé.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 5 - Absence du client
                    </Typography>
                    <Typography variant="body1" paragraph>
                        En cas d'absence de votre part, aucun remboursement et aucun report ne pourra être accordé.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 6 - Assurance
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Nos offres de services sont couvertes par notre assurance responsabilité civile.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 7 - Matériel
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Vous vous engagez à remplacer ou à couvrir les frais de réparation du matériel qui vous est confié au cas où vous l'égareriez ou l'endommageriez.
                    </Typography>

                    <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
                        Article 8 - Droit de rétractation
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Le client est informé que dans le cadre de la vente des billets sur les sites internet officiels : http://www.laguneplongee.com, il ne bénéficie pas du droit de rétractation.
                    </Typography>
                </Box>

                {/* Protection des données */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom color="primary">
                        4. Protection des données personnelles (RGPD)
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Conformément au Règlement Général sur la Protection des Données (RGPD), nous nous engageons à protéger vos données personnelles. Les informations collectées lors de vos réservations sont utilisées uniquement pour la gestion de vos prestations et ne sont pas transmises à des tiers sans votre consentement.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition concernant vos données personnelles. Pour exercer ces droits, contactez-nous à : infolaguneplongee@gmail.com
                    </Typography>
                </Box>

                {/* Cookies */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom color="primary">
                        5. Cookies
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Ce site utilise des cookies pour améliorer votre expérience de navigation et analyser le trafic. En continuant à utiliser ce site, vous acceptez l'utilisation de cookies conformément à notre politique de confidentialité.
                    </Typography>
                </Box>

                {/* Propriété intellectuelle */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom color="primary">
                        6. Propriété intellectuelle
                    </Typography>
                    <Typography variant="body1" paragraph>
                        L'ensemble du contenu de ce site (textes, images, vidéos, logos) est protégé par le droit d'auteur et appartient à LAGUNE PLONGEE ou à ses partenaires. Toute reproduction ou utilisation sans autorisation est interdite.
                    </Typography>
                </Box>

                {/* Dernière mise à jour */}
                <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid #e0e0e0' }}>
                    <Typography variant="body2" color="text.secondary" align="center">
                        Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}<br />
                        Date de création des CGV : 30 décembre 2009
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default LegalMentions;
